import { GestureOverlayContainer } from './GestureOverlayContainer'
import { MoveOverlayBody } from './MoveOverlay'
import { ResizeBody } from './ResizeOverlay'
import { OrientationOverlayProps } from './types'

export const OrientationOverlay = ({
  zoom,
  position = [0, 0],
  resize,
  onMove,
  onDragStart,
  onDragEnd,
  onDelete,
}: OrientationOverlayProps) => (
  <GestureOverlayContainer zoom={zoom} onDelete={onDelete}>
    {onMove ? (
      <MoveOverlayBody
        position={position}
        onMove={onMove}
        zoom={zoom}
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
      />
    ) : null}
    {resize ? <ResizeBody zoom={zoom} {...resize} /> : null}
  </GestureOverlayContainer>
)
